import type { HostPublicProfile } from '@/mocks/hostProfile';

interface Props {
  profile: HostPublicProfile;
}

const categoryLabels: Record<string, string> = {
  programas: 'Programa',
  entrevistas: 'Entrevista',
  eventos: 'Evento',
  shorts: 'Short',
  promociones: 'Promo',
};

export default function HostVideosSection({ profile }: Props) {
  const videos = profile.videos.filter((v) => v.status === 'publicado');

  if (videos.length === 0) return null;

  return (
    <section id="videos" className="scroll-mt-24">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-video-line text-accent-500"></i>
          Videos
        </h2>
        <span className="text-xs text-foreground-500 bg-background-100 px-2 py-1 rounded-full">
          {videos.length} videos
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {videos.map((video) => (
          <div key={video.id} className="group bg-white rounded-xl border border-foreground-100 overflow-hidden hover:shadow-sm transition-all cursor-pointer">
            <div className="relative w-full aspect-video overflow-hidden">
              <img
                src={video.thumbnailUrl}
                alt={video.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
              <div className="absolute bottom-2 right-2 bg-black/70 text-white text-[10px] font-medium px-1.5 py-0.5 rounded">
                {video.duration}
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center">
                  <i className="ri-play-fill text-foreground-900 text-lg ml-0.5"></i>
                </div>
              </div>
              {video.isFeatured && (
                <span className="absolute top-2 left-2 bg-accent-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">
                  Destacado
                </span>
              )}
            </div>
            <div className="p-3">
              <h3 className="font-medium text-foreground-950 text-xs leading-snug line-clamp-2 group-hover:text-accent-600 transition-colors">{video.title}</h3>
              <div className="flex items-center justify-between mt-2">
                <span className="text-[10px] text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded-full">
                  {categoryLabels[video.category] || video.category}
                </span>
                <span className="text-[10px] text-foreground-400">
                  {new Date(video.uploadedAt).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}